
<template lang="pug">
  .sidecart__line-item__quantity
    icon-button.sidecart__line-item__quantity__change(
      label="Decrement Count"
      icon="minus"
      height="11px"
      width="11px"
      :disabled="disableDecrement"
      @click="decrement"
    )
    p.sidecart__line-item__quantity__label {{ quantity }}
    icon-button.sidecart__line-item__quantity__change(
      label="Increment Count"
      icon="plus"
      height="11px"
      width="11px"
      :disabled="disableIncrement",
      @click="increment"
    )
</template>

<script>
  import IconButton from 'scripts/components/buttons/IconButton.vue';

  export default {
    name: 'SidecartQuantitySelector',
    components: {
      IconButton,
    },
    props: {
      quantity: Number,
      disableIncrement: {
        type: Boolean,
        default: false,
      },
      disableDecrement: {
        type: Boolean,
        default: false,
      },
    },
    methods: {
      increment () {
        this.$emit('increment');
      },
      decrement () {
        this.$emit('decrement');
      },
    },
  };
</script>

<style scoped lang="scss">
  .sidecart__line-item__quantity {
    display: flex;
    align-items: center;
    margin-top: $grid-gutter;
    border: 1px solid $border--lightest;
    max-width: 96px;

    &__label {
      margin: 0;
      min-width: 27px;
      text-align: center;
      font-size: rem(14);
      line-height: 0.8;
      font-family: $font-gibson;
      color: $color--primary;
    }

    .icon {
      fill: $color--primary;
    }

    &__change {
      width: 28px;
      height: 28px;

      &[disabled] {
        background-color: transparent;
        opacity: 0.3;
      }
    }
  }
</style>
